






































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import SelectPopover from "@/components/SelectPopover.vue";

@Component({
  components: { SelectPopover },
  computed: mapState("auth", ["user", "entityId"]),
})
export default class Header extends Vue {
  @Prop(String) readonly title!: string;
  entityTabsOverflown = false;
  entityId!: string;
  setEntity(entity: any) {
    const id: string = entity ? entity.id : "";
    this.$store.commit("auth/SET_ENTITY", id);
    // GAPS
    this.$store.commit("gaps/RESET_FILTER", id);
    this.$store.dispatch("gaps/getCampaigns");
    this.$store.dispatch("gaps/getInsurers");
    this.$store.dispatch("gaps/getProviders");
    this.$store.dispatch("gaps/getPriority");
    this.$store.dispatch("gaps/getSubStatus");
    this.$store.dispatch("gaps/getReasons");
    this.$store.dispatch("gaps/getUsers");
    this.$store.dispatch("gaps/getIPA");
    this.$store.dispatch("gaps/getReportLinks");
    this.$store.dispatch("gaps/getLogTypes");
    // CASES
    this.$store.commit("cases/RESET_FILTER", id);
    this.$store.commit("cases/RESET_CASE_TASKS_FILTER", id);
    this.$store.dispatch("cases/getTypes");
    this.$store.dispatch("cases/getActivity");
    this.$store.dispatch("cases/getTriggers");
    this.$store.dispatch("cases/getReferralSources");
    this.$store.dispatch("cases/getCloseReasons");
    this.$store.dispatch("cases/getForms");
    this.$store.dispatch("cases/getClinicalIndicators");
    this.$store.dispatch("cases/getUsers");
    this.$store.dispatch("cases/getCarePlanTypes");
    this.$store.dispatch("cases/getCarePlanProblems");
    this.$store.dispatch("cases/getCarePlanInterventions");
    this.$store.dispatch("cases/getCarePlanGoals");
    this.$store.dispatch("cases/getCarePlanTasks");
    // SCHEDULE
    this.$store.commit("schedule/RESET_FILTER", id);
    this.$store.dispatch("schedule/getCalendars");
    this.$store.dispatch("schedule/getCalendarReasons");
    this.$store.dispatch("schedule/getPriorities");
    this.$store.dispatch("schedule/getStatus");
    // CALLS
    // this.$store.commit("calls/RESET_FILTER", id);
    // this.$store.commit("calls/RESET_TABS", id);
    // this.$store.dispatch("calls/getDates");
    // this.$store.dispatch("calls/getPhones");
    // this.$store.dispatch("calls/getReasons");
    // this.$store.dispatch("calls/getUsers");
    // this.$store.dispatch("calls/getStatus");
    // this.$store.dispatch("calls/getRecordings");
    // this.$store.dispatch("calls/getFlows");
    // this.$store.dispatch("calls/getFilters");
    // SCROLL INTO VIEW
    if (id) {
      const tab = document.getElementById(`entity-${id}`);
      tab!.scrollIntoView();
    }
    //
    this.$emit("entity-changed");
  }
  scrollStart() {
    this.entityTabs()!.scrollTo(0, 0);
  }
  scrollLeft() {
    const left = this.entityTabs()!.scrollLeft;
    this.entityTabs()!.scrollTo(left - 100, 0);
  }
  scrollRight() {
    const left = this.entityTabs()!.scrollLeft;
    this.entityTabs()!.scrollTo(left + 100, 0);
  }
  scrollEnd() {
    this.entityTabs()!.scrollTo(this.entityTabs()!.scrollWidth, 0);
  }
  entityTabs() {
    return document.getElementById("entity-tabs");
  }
  mounted() {
    // GAPS
    this.$store.dispatch("gaps/getCampaigns");
    this.$store.dispatch("gaps/getInsurers");
    this.$store.dispatch("gaps/getMeasures");
    this.$store.dispatch("gaps/getMeasureTypes");
    this.$store.dispatch("gaps/getPriority");
    this.$store.dispatch("gaps/getStatus");
    this.$store.dispatch("gaps/getSubStatus");
    this.$store.dispatch("gaps/getReasons");
    this.$store.dispatch("gaps/getUsers");
    this.$store.dispatch("gaps/getIPA");
    this.$store.dispatch("gaps/getReportLinks");
    this.$store.dispatch("gaps/getLogTypes");
    // CASES
    this.$store.dispatch("cases/getTypes");
    this.$store.dispatch("cases/getActivity");
    this.$store.dispatch("cases/getTriggers");
    this.$store.dispatch("cases/getReferralSources");
    this.$store.dispatch("cases/getCloseReasons");
    this.$store.dispatch("cases/getRiskLevels");
    this.$store.dispatch("cases/getStatus");
    this.$store.dispatch("cases/getForms");
    this.$store.dispatch("cases/getClinicalIndicators");
    this.$store.dispatch("cases/getUsers");
    this.$store.dispatch("cases/getCarePlanTypes");
    this.$store.dispatch("cases/getCarePlanProblems");
    this.$store.dispatch("cases/getCarePlanProblemStatus");
    this.$store.dispatch("cases/getCarePlanInterventions");
    this.$store.dispatch("cases/getCarePlanInterventionStatus");
    this.$store.dispatch("cases/getCarePlanGoals");
    this.$store.dispatch("cases/getCarePlanGoalStatus");
    this.$store.dispatch("cases/getCarePlanTasks");
    this.$store.dispatch("cases/getCarePlanTaskStatus");
    this.$store.dispatch("cases/getCarePlanTaskPriority");
    // PATIENTS
    this.$store.dispatch("patients/getPhoneStatus");
    // SCHEDULE
    this.$store.dispatch("schedule/getCalendars");
    this.$store.dispatch("schedule/getStatus");
    this.$store.dispatch("schedule/getTypeStatus");
    this.$store.dispatch("schedule/getPriorities");
    this.$store.dispatch("schedule/getCalendarReasons");
    //PROVIDER
    this.$store.dispatch("providers/getSpecialties");
    // CALLS
    // this.$store.dispatch("calls/getPhones");
    // this.$store.dispatch("calls/getReasons");
    // this.$store.dispatch("calls/getUsers");
    // this.$store.dispatch("calls/getStatus");
    // this.$store.dispatch("calls/getRecordings");
    // this.$store.dispatch("calls/getFlows");
    // this.$store.dispatch("calls/getFilters", true);
    //
    this.entityTabsOverflown =
      this.entityTabs()!.scrollWidth > this.entityTabs()!.clientWidth;
  }
}
